import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SocialSharing from 'components/SocialSharing';
import style from './style.scss'; //NOSONAR

const FabSocialSharing = (props) => {
    const [open, setOpen] = useState(false);
    const {info, product,tooltip} = props;

    const settings = {
        facebook: true,
        messenger: false,
        twitter: true,
        whatsapp: true,
        mail: true
    };

    useEffect(() => {
        if(props.settings){
            Object.assign(settings, props.settings);
        }
    })

    const click = () => {
        setOpen(!open);
    }

    return(
        <div className={'fab-social-sharing ' + (open ? 'open' : '') }>                               
            {(info || product) && <SocialSharing info={info} product={product}/>}
            <button type="button" className="fab-social-sharing-list-share font-icn share tooltip-container" onClick={click}>
                <span className="tooltip">{tooltip ? tooltip : 'Compartir Lista'}</span>
            </button>
        </div>
    )
}

FabSocialSharing.propTypes = {
    settings: PropTypes.object,
    info: PropTypes.object,
    product: PropTypes.object,
    tooltip: PropTypes.string 
}

export default FabSocialSharing;
